import * as React from 'react'
import { IVehicleObj } from '../../../types'

import NumberIncrementSelector from '../../ui/NumberIncrementSelector'
import UIMessages from '../../../utils/ui-messages'

const AccessCapacity = (props: { vehicle: IVehicleObj }) => {
  return (
    <div className='ml3'>
      <div className='bold font-dark-grey mt2'>Access</div>

      {props.vehicle.capacities.some(it => it.wheelchair > 0) && (
        <div className='h5 font-dark-grey mt2'>{UIMessages.vehicle.wheelchair}</div>
      )}
      {props.vehicle.capacities.some(it => it.cot > 0) && (
        <div className='h5 font-dark-grey mt2'>{UIMessages.vehicle.cot}</div>
      )}

      <div className='bold font-dark-grey mt3'>Capacity</div>
      <div className='mt1 flex flex-wrap'>
        {props.vehicle.capacities.map((it, i) => (
          <div className='p2 border-light-grey4 rounded w277 mr2 mb2' key={it.id}>
            <div className='font-light-blue-grey h6'>Option {i + 1}</div>
            <div className='flex items-center'>
              <div className='h5'>{UIMessages.vehicle.passengerSeats}</div>
              <NumberIncrementSelector value={it.amble} />
            </div>
            <div className='flex items-center'>
              <div className='h5'>{UIMessages.vehicle.wheelchair}</div>
              <NumberIncrementSelector value={it.wheelchair} />
            </div>
            <div className='flex items-center'>
              <div className='h5'>{UIMessages.vehicle.cot}</div>
              <NumberIncrementSelector value={it.cot} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AccessCapacity



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/AccessCapacity.tsx